/**
 * Query keys do domínio organizations (apps/sales, apps/admin).
 *
 * "Organização" cobre tanto agência quanto clube — escopos são
 * desambiguados pelo segundo nível (`visible`, `by-id`, `members`).
 */
import { tuple } from "./core";

const root = ["organizations"] as const;

export const organizations = {
  all: root,
  /** Lista organizações visíveis pelo usuário atual (RLS aplicada). */
  visible: tuple(root, "visible"),
  byId: (orgId: string | null | undefined) => tuple(root, "detail", orgId),
  members: (orgId: string | null | undefined) => tuple(root, "members", orgId),
} as const;
